const conflictingStaffIcon = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
      >
        <g clipPath="url(#clip0_590_7333)">
          <mask
            id="mask0_590_7333"
            mask-type="luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="48"
            height="48"
          >
            <path d="M48 0H0V48H48V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_590_7333)">
            <mask
              id="mask1_590_7333"
              mask-type="luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="48"
              height="48"
            >
              <path d="M48 0H0V48H48V0Z" fill="white" />
            </mask>
            <g mask="url(#mask1_590_7333)">
              <path
                d="M39 48H9C4.02905 48 0 43.9709 0 39V9C0 4.02905 4.02905 0 9 0H39C43.9709 0 48 4.02905 48 9V39C48 43.9709 43.9709 48 39 48Z"
                fill="#ECF5EE"
              />
              <path
                d="M25.9995 16.9995C25.9995 19.7607 23.7612 21.999 21 21.999C18.2388 21.999 16.0005 19.7607 16.0005 16.9995C16.0005 14.2383 18.2388 12 21 12C23.7612 12 25.9995 14.2383 25.9995 16.9995Z"
                fill="#449F52"
              />
              <path
                d="M21.4995 29.5005C21.4995 27.3706 22.3425 25.4355 23.7045 24H16.749C14.1313 24 12 26.1313 12 28.7505V32.25C12 32.6638 12.3362 33 12.75 33H22.3169C21.7994 31.9409 21.4995 30.7559 21.4995 29.5005Z"
                fill="#449F52"
              />
            </g>
          </g>
          <path
            d="M29.501 23C25.9175 23 23 25.916 23 29.4995C23 33.083 25.916 36.0005 29.501 36.0005C33.086 36.0005 36.0005 33.0845 36.0005 29.501C36.0005 25.9175 33.0845 23 29.501 23ZM32.753 27.9095L29.2535 31.91C29.072 32.1185 28.811 32.2415 28.5335 32.2505C28.523 32.2505 28.511 32.2505 28.5005 32.2505C28.2365 32.2505 27.9815 32.1455 27.794 31.958L25.7945 29.9585C25.4045 29.5685 25.4045 28.9355 25.7945 28.544C26.1845 28.1525 26.8175 28.154 27.209 28.544L28.4525 29.7875L31.2485 26.591C31.613 26.177 32.2445 26.1335 32.66 26.4965C33.0755 26.8625 33.1175 27.4925 32.753 27.9095Z"
            fill="#A1CFA8"
          />
        </g>
        <defs>
          <clipPath id="clip0_590_7333">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};
export default conflictingStaffIcon;
